// extracted by mini-css-extract-plugin
export default {"root":"dd-PY","icon":"foNt4","up":"x3+8I","right":"Rg9nS"};